import { observer } from "mobx-react-lite";
import React, { useCallback, useState } from "react";

import Svg from "../../../components/svg/Svg";
import { CustomerSupport, ExternalLink } from "../../../components/svg/svgImageList";
import { api } from "../../../services/api/ApiService";
import useErrorHandler, {
  ApplicationError,
} from "../../../services/error-handler/ErrorHandlerService";
import { translationService } from "../../../services/translation/TranslationService";
import { ZendeskStorageModel } from "../../../services/zendesk/ZendeskStorage";
import "./composition.scss";

export const CustomerSupportCard = observer(() => {
  const { handleErrorInSnackbar } = useErrorHandler();
  const [zendeskStorage] = useState(() => ZendeskStorageModel.create({}, { api }));

  const shouldDisplayAddTicketOption = useCallback(() => {
    return (
      !zendeskStorage.zendeskUserDetails.exists ||
      (zendeskStorage.zendeskUserDetails.exists && zendeskStorage.zendeskUserDetails.verified)
    );
  }, [zendeskStorage]);

  const doAction = useCallback(async () => {
    try {
      if (!zendeskStorage.zendeskUserDetails.exists) {
        await zendeskStorage.createZendeskUser();
      } else if (
        zendeskStorage.zendeskUserDetails.verified &&
        zendeskStorage.zendeskUserDetails.exists
      ) {
        window.open("https://support.esic.cloud/");
      }
    } catch (error) {
      const applicationError = error as ApplicationError;
      applicationError.withErrorMessage("default-error.help.add-ticket");
      handleErrorInSnackbar(applicationError);
    }
  }, [handleErrorInSnackbar, zendeskStorage]);

  return (
    <div className="help-card">
      <div className="help-card-title">
        {translationService.translate("HelpPage.customer-support-title")}
      </div>
      <Svg className="help-card-icon" svg={CustomerSupport} />
      {shouldDisplayAddTicketOption() ? (
        <div className="help-card-option customer-support" onClick={doAction}>
          {translationService.translate("HelpPage.customer-support-option")}
          <Svg svg={ExternalLink} />
        </div>
      ) : (
        <div>{translationService.translate("HelpPage.customer-support-activate-account")}</div>
      )}
    </div>
  );
});
